import styled from 'styled-components';
import { connect } from 'react-redux';
import { SmallDroppableTileList } from '../SmallTile';

const Container = styled.div`
  ::-webkit-scrollbar {
    display: none; /* Chrome Safari */
  }
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none; /* IE 10+ */
`;

const TileList = props => {
  return (
    <Container>
      <SmallDroppableTileList
        bucketDate={props.bucketDate}
        dndContext={props.dndContext}
        tilesPerRow={200}
        showAllItems={true}
      />
    </Container>
  );
};

const mapStateToProps = state => ({
  dndContext: state.dndContext,
});

export { TileList };

export default connect(mapStateToProps)(TileList);
